import { Spinner } from "ui";

type Props = {
  columnAmount: number;
};

const TableBodyLoadingState = ({ columnAmount }: Props) => (
  <tr>
    <td colSpan={columnAmount}>
      <div className="p-4 flex justify-center text-sm text-center text-white font-bold">
        <Spinner size={50} />
      </div>
    </td>
  </tr>
);

export default TableBodyLoadingState;
